import { Link } from 'components/Atoms/Link'
import { SingleAchievementCSS } from './SingleAchievementCSS.styled'
import { CONTENT_TYPES } from 'constants/games/contentTypes'
import { useYoloToast } from 'lib/yoloToasts/useYoloToast'
import { useEffect, useMemo } from 'react'
import { icons } from 'common'
import ms from 'ms.macro'

export const SingleAchievement = ({ msg, noToast }) => {
  const paragraph = useMemo(
    () => (
      <>
        Congrats - you've now completed the <b>{msg.achievementName}</b> goal, which earns you an extra{' '}
        {msg.achievementXp} XP.
        <br />{' '}
        <Link to={`/game/${CONTENT_TYPES.ACHIEVEMENT}`} className='header_link' type='button'>
          Keep going to earn more rewards!
        </Link>
      </>
    ),
    [msg?.achievementName, msg?.achievementXp]
  )

  //Toast Logic
  const { yToast } = useYoloToast()
  useEffect(() => {
    if (noToast) return
    const announcementToastObj = {
      id: 'achievementToast',
      autoClose: ms`15s`,
      props: {
        icon: icons.ach_check_checked_3_dark,
        message: {
          title: <strong>ACHIEVEMENT GOAL REACHED</strong>,
          subtitle: paragraph,
        },
      },
    }
    yToast(announcementToastObj)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  //Toast Logic

  return (
    <SingleAchievementCSS>
      <div className='message user achivement_announcement_private'>
        <div className='user_avatar'>
          <div className='avatar_image'></div>
        </div>
        <div className='message_content'>
          <span className='user_name'> ACHIEVEMENT GOAL REACHED</span>
          <span className='message_copy'>{paragraph}</span>
        </div>
      </div>
    </SingleAchievementCSS>
  )
}
